export default [
    { key: 'user.name', label: 'Usuario' },
    { key: 'notes', label: 'Notas' },
    { key: 'created_at', label: 'Fecha creación' }
]